import { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/routers/constant'

const router: Array<RouteRecordRaw> = [
  {
    path: '/business/feedback',
    component: Layout,
    redirect: '/business/feedback/index',
    meta: {
      title: '留言管理',
      keepAlive: true,
      requiresAuth: true
    },
    children: [
      {
        path: 'index',
        name: 'BusinessFeedbackIndex',
        component: () => import('@/views/business/feedback/index.vue'),
        meta: {
          keepAlive: true,
          requiresAuth: true,
          title: '留言管理'
        }
      }
    ]
  }
]

export default router
